import AppHeader from '../AppHeader'
let utils = require('../../utils')
export default {
  name: 'shop-order-history-list',
  async created () {
    this.getSearchItems()
    this.getShopOrdersHistoryListSearch()
    utils.scrollBottomSearchEvent(this.getShopOrdersHistoryList, '', 'button.next-page-search-btn')
  },
  data () {
    return {
      shopNames: [],
      yearMonths: {},
      weeklyNumbers: [],
      currentWeeklyNumbers: [],
      queryShopName: '',
      queryYearMonth: '',
      queryWeeklyNumber: '',
      shopOrders: [],
      getSearchItemsFlag: false,
      getSearchShopHistoriesFlag: false,
      nextPage: 1,
    }
  },
  computed: {},
  components: {
    AppHeader
  },
  methods: {
    async getSearchItems () {
      const res = await this.$store.dispatch('SHOP_ORDERS_HISTORY_SEARCH_ITEM_GET')
      .catch(err => {
        console.log(err)
        return
      })
      this.shopNames = res.data.shop_names
      this.yearMonths = res.data.year_months
      this.weeklyNumbers = res.data.weekly_numbers
      this.getSearchItemsFlag = true
    },
    async getShopOrdersHistoryListSearch () {
      this.nextPage = 1
      this.shopOrders = []
      this.getShopOrdersHistoryList()
      this.getSearchShopHistoriesFlag = false
    },
    async getShopOrdersHistoryList () {
      const data = {
        shop_name: this.queryShopName,
        year_month: this.queryYearMonth,
        weekly_number: this.queryWeeklyNumber,
        page: this.nextPage,
      }
      const res = await this.$store.dispatch('SHOP_ORDERS_HISTORY_LIST', data)
                  .catch(err => {
                    console.log(err)
                    return
                  })
      res.data.data.map(order => {
        let converedOrder = {}
        converedOrder = utils.kebabSnakeConversion(order.attributes)
        converedOrder.id = order.id
        this.shopOrders.push(converedOrder)
      })
      this.nextPage = res.data.meta['next-page']
      this.getSearchShopHistoriesFlag = true
    },
    async setCurrentWeeklyNumbers () {
      this.queryWeeklyNumber = ''
      this.currentWeeklyNumbers = []
      const tmpQueryYearMonth = this.queryYearMonth
      const tmpCurrentWeeklyNumbers = await this.weeklyNumbers.filter(weeklyNumber => {
        return weeklyNumber.weekly_number_key === Number(tmpQueryYearMonth)
      })
      this.currentWeeklyNumbers = tmpCurrentWeeklyNumbers[0].weekly_numbers
    },
    async goShopOrderHistory (shopOrderId) {
      this.$router.push(`/shop_order/history/${shopOrderId}/detail`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop-order-history-list.js